import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '@carbon/react';
import { Add, Compare } from '@carbon/react/icons';
import { PageHeader } from 'components/page-header';
import { pageTitle } from 'utils/page-title';
import routes from '~/routes';
import PackageLibraryContent from './package-library-content';
import style from './page.module.scss';

const ListPackagesPage: FC = () => {
  const history = useHistory();

  return (
    <>
      <Helmet>
        <title>{pageTitle('Packages')}</title>
      </Helmet>
      <PageHeader
        breadcrumbs={[['packages', 'Packages']]}
        title="Packages"
        actions={
          <div className={style.headerActions}>
            {/* size="md" (not "sm") so the labels always stay visible: the shared
                PageHeader only collapses `sm` action buttons to icon-only at laptop
                widths — `md` buttons keep their text at every width. */}
            <Button
              kind="tertiary"
              size="md"
              renderIcon={Compare}
              onClick={() => window.open(routes.compareWizardPath, '_blank')}
            >
              Compare
            </Button>
            <Button
              kind="primary"
              size="md"
              renderIcon={Add}
              onClick={() => history.push(routes.newPackagePath)}
            >
              Create Package
            </Button>
          </div>
        }
      />
      <PackageLibraryContent />
    </>
  );
};

export { ListPackagesPage };
